import { flux } from '@/core/flux.module';
import type { HierarchyOutputV1 } from '@/sdk/model/HierarchyOutputV1';

export const setAliasColumnId = (aliasColumnId?: string) =>
  flux.dispatch('ASSET_BUILDER_SET_ALIAS_COLUMN_ID', { aliasColumnId });

export const setHierarchyOutput = (hierarchyOutput?: HierarchyOutputV1) =>
  flux.dispatch('ASSET_BUILDER_SET_HIERARCHY_OUTPUT', { hierarchyOutput });

export const resetAssetBuilder = () => flux.dispatch('ASSET_BUILDER_RESET');

export const setName = (name: string) => flux.dispatch('ASSET_BUILDER_SET_NAME', { name });

export const setDescription = (description: string | undefined) =>
  flux.dispatch('ASSET_BUILDER_SET_DESCRIPTION', { description });
